import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { FileText, Search, Map, Bot, LayoutDashboard } from 'lucide-react';
import { Section } from './ui/Section';
const deliverables = [{
  icon: FileText,
  title: 'The High-Performance Solopreneur Blueprint (PDF)',
  desc: 'El manual paso a paso de 54 páginas con la estrategia completa.'
}, {
  icon: Search,
  title: 'Auditoría de Fugas de 24hs',
  desc: 'La herramienta para identificar exactamente dónde estás regalando tu tiempo.'
}, {
  icon: Map,
  title: 'Mapa de Conectividad No-Code',
  desc: 'Guía visual para unir tus cobros con tu entrega de servicio automáticamente.'
}, {
  icon: Bot,
  title: 'Entrenamiento de Clon Digital',
  desc: 'Cómo darle tu voz a la IA para que redacte y atienda por vos sin sonar robótica.'
}, {
  icon: LayoutDashboard,
  title: 'Dashboard del Operador Invisible',
  desc: 'La plantilla para controlar todo tu negocio en una sola pantalla.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function DeliverablesSection() {
  return <Section className="px-6 md:px-12 max-w-5xl mx-auto" data-id="element-121">
      <div className="text-center mb-16" data-id="element-122">
        <span className="font-mono text-[#d4a853] text-sm tracking-widest uppercase mb-4 block" data-id="element-123">
          03 // El Arsenal
        </span>
        <h2 className="font-serif text-3xl md:text-4xl font-semibold text-gray-100" data-id="element-124">
          Qué obtenés exactamente hoy
        </h2>
      </div>

      <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-50px'
    }} className="grid gap-4 md:gap-6" data-id="element-125">
        {deliverables.map((item, i) => {
        const Icon = item.icon;
        return <motion.div key={i} variants={itemVariants} className="flex flex-col md:flex-row md:items-center p-6 md:p-8 border border-gray-800 bg-[#111827]/40 hover:bg-[#111827]/80 hover:border-[#b8860b]/40 transition-all duration-300 group" data-id="element-126">
              <div className="mb-4 md:mb-0 md:mr-6 p-4 bg-[#0a0a0a] border border-[#d4a853]/20 group-hover:border-[#d4a853]/50 transition-colors" data-id="element-127">
                <Icon className="w-6 h-6 text-[#d4a853]" strokeWidth={1.5} data-id="element-128" />
              </div>
              <div data-id="element-129">
                <h3 className="font-serif text-xl text-[#f0c674] mb-2" data-id="element-130">
                  {item.title}
                </h3>
                <p className="font-sans text-gray-400 leading-relaxed" data-id="element-131">
                  {item.desc}
                </p>
              </div>
            </motion.div>;
      })}
      </motion.div>
    </Section>;
}